import React from 'react';
export var SubHeaderBannersLayout = function (_a) {
    var hasBannersToDisplay = _a.hasBannersToDisplay, children = _a.children;
    var wrapperIndent = {
        paddingTop: hasBannersToDisplay ? '15px' : 0,
        paddingRight: '15px',
        paddingLeft: '15px',
        marginBottom: '-15px'
    };
    if (!hasBannersToDisplay) {
        return null;
    }
    return (React.createElement("div", { style: wrapperIndent }, children));
};
